import React, { useState, useEffect } from "react";
import api from "../../services/api";

function AddActivity({ onSave, onCancel, saving = false }) {
  const [activityTypes, setActivityTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    type: "",
    description: "",
    scheduledDate: new Date().toISOString().slice(0, 16),
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    loadActivityTypes();
  }, []);

  const loadActivityTypes = async () => {
    setLoading(true);
    try {
      const data = await api.getMasterData("activityTypes");
      // Check if data is valid and has items
      if (data && Array.isArray(data) && data.length > 0) {
        setActivityTypes(data);
      } else {
        // Fallback activity types if API returns empty
        setActivityTypes([
          { id: 1, name: "Phone Call" },
          { id: 2, name: "Email" },
          { id: 3, name: "Meeting" },
          { id: 4, name: "Follow-up" },
          { id: 5, name: "Note Added" },
          { id: 6, name: "Lead Created" },
          { id: 7, name: "Status Changed" },
        ]);
      }
    } catch (err) {
      console.error("Failed to load activity types:", err);
      // Set fallback activity types
      setActivityTypes([
        { id: 1, name: "Phone Call" },
        { id: 2, name: "Email" },
        { id: 3, name: "Meeting" },
        { id: 4, name: "Follow-up" },
        { id: 5, name: "Note Added" },
      ]);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!formData.type) newErrors.type = "Activity type is required";
    if (!formData.description || !formData.description.trim()) {
      newErrors.description = "Description is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onSave(formData);
  };

  if (loading) {
    return (
      <div className="loading-spinner" style={{ padding: "20px" }}>
        Loading activity types...
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="add-activity-form">
      <div className="form-row">
        <div className="form-group">
          <label>Activity Type *</label>
          <select
            name="type"
            className={`form-control ${errors.type ? "error" : ""}`}
            value={formData.type}
            onChange={handleChange}
            disabled={saving}
          >
            <option value="">Select type</option>
            {activityTypes.map((type) => (
              <option key={type.id} value={type.name}>
                {type.name}
              </option>
            ))}
          </select>
          {errors.type && <div className="error-text">{errors.type}</div>}
        </div>
      </div>
      <div className="form-group">
        <label>Description *</label>
        <textarea
          name="description"
          className={`form-control ${errors.description ? "error" : ""}`}
          rows="3"
          value={formData.description}
          onChange={handleChange}
          placeholder="Enter activity details..."
          disabled={saving}
        />
        {errors.description && (
          <div className="error-text">{errors.description}</div>
        )}
      </div>
      <div className="form-actions">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={onCancel}
          disabled={saving}
        >
          Cancel
        </button>
        <button type="submit" className="btn btn-primary" disabled={saving}>
          {saving ? (
            <>
              <i className="fas fa-spinner fa-spin"></i> Saving...
            </>
          ) : (
            <>
              <i className="fas fa-save"></i> Save Activity
            </>
          )}
        </button>
      </div>
    </form>
  );
}

export default AddActivity;
